import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';
import Lenis from 'lenis';

import { fetch_one } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import QRCode from "react-qr-code";

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import QrCodeIcon from '@mui/icons-material/QrCode';

// import Lenis from "lenis";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
} from '@mui/material';
// import {
//   WhiteSection
// } from '../../../components/v2/custom';
import {
  DarkGreenButton,
  IconButton,
  LightGreenButton,
  ShareShower,
  Stepper,
  TextButton,
  TextInput,
  Typography
} from '../../../../components/v2/styled';
import { OtpCode } from '../../../../components/v2/styled/OtpCode';
import { Vennr } from '../../../../components/v2/styled/Vennr';
import { Birthdate } from '../../../../components/v2/styled/Birthdate';
import { WhiteSection } from '../../../../components/v2/custom';

import { EmissionKey } from '../../../../models/EmissionKey';
import { User } from '../../../../models/User';

var he = require('he');
const { DateTime } = require("luxon");

type Props = {
  setStep: (n:number) => void;
  lenis: Lenis;
}

export const EmissionGiftBuyGift: FunctionComponent<Props> = ({setStep, lenis}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [vennr, setVennr] = useState<string>('');
  const [birthdate, setBirthdate] = useState<string>('');
  const [otp, setOtp] = useState<string>('');
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [user, setUser] = useState<User>({
    id: undefined,
    auth_token: '',
    email: ''
  });
  const [theKey, setTheKey] = useState<EmissionKey>({});
  const [amount, setAmount] = useState<number>(1);
  const [firstName, setFirstName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [subStep, setSubStep] = useState<number>(-1);
  const [showQr, setShowQr] = useState<boolean>(false);
  const [validateError, setValidateError] = useState<boolean>(false);










  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      step: number;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);

      setShowOtp(false);

      if (variables.step === 0) { // verification
        if (!!data.custom_result.mfa_status_0_verification) {
          setShowOtp(true);
        } else {
          if (!data.custom_result.message) {
            setUser({
              id: data.custom_result.id,
              first_name: data.custom_result.first_name,
              last_name: data.custom_result.last_name,
              vennoot_number: data.custom_result.vennoot_number,
              guardian: data.custom_result.guardian,
              email: '',
              auth_token: ''
            });
            setSubStep(0);
          } else {
            setValidateError(true);
          }
        }
      } else { // order complete
        setSubStep(4);
      }

      if (!!data.custom_result.user) {
        setUser({
          ...data.custom_result.user,
          birth_date: DateTime.fromISO(data.custom_result.user?.birth_date).toFormat("dd/LL/y")
        });
      }
      if (!!data.custom_result.active_key) {
        setTheKey({
          ...data.custom_result.active_key
        });
      }
    },
  });









  const emailCheck = (email:string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }
  const subBtns = (backStep:number, nextStep:number, disabled:boolean) => {
    return <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
      <Box sx={{
        display: 'block',
        width: '100%',
        maxWidth: {
          xs: '100%',
          lg: '440px'
        },
        marginTop: 2,
        marginRight: 'auto',
        marginLeft: 'auto',
        textAlign: 'right'
      }}>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          textAlign: 'left',
          float: 'left'
        }}>
          <TextButton
            label={t("nw.emission.forgot.cta_back")}
            id="sub_btn"
            disabled={backStep < 0}
            onClick={() => {
              setSubStep(backStep);
              setTimeout(() => {
                // lenis.scrollTo("top");
                window.scrollTo(0, 0);
              }, 200);
            }}
            sx={{
              marginBottom: 1,
              color: theme.palette.primary.dark,
              textDecoration: 'underline',
              "&:hover": {
                color: theme.palette.primary.light,
                backgroundColor: 'transparent'
              },
              paddingLeft: 0,
              paddingRight: 0
            }}
          />
        </Box>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          marginLeft: 'auto',
          textAlign: 'right'
        }}>
          <DarkGreenButton
            label={t("nw.register.hero.cta")}
            id="sub_btn"
            sx={{
              marginBottom: 1,
              borderColor: theme.palette.primary.dark,
              "&:hover": {
                borderColor: theme.palette.primary.dark,
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.dark,
              },
              "&.Mui-disabled": {
                color: 'grey',
              },
            }}
            disabled={disabled}
            onClick={() => {
              setSubStep(nextStep);
              setTimeout(() => {
                // lenis.scrollTo("top");
                window.scrollTo(0, 0);
              }, 200);
            }}
          />
        </Box>
      </Box>
    </Grid>
  }










  const tableRow = (label: string, content: string|undefined, children: any, divider: boolean, copyable?: boolean, lessPadding?: boolean) => {
    return <>
      <Grid item xs={12} sm={4} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingLeft: {
          xs: 1,
          md: 2,
          lg: 3
        }
      }}>
        <Typography sx={{
          textTransform: 'uppercase',
          color: theme.palette.primary.light
        }}>{label}</Typography>
      </Grid>
      <Grid item xs={12} sm={8} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingRight: {
          xs: 1,
          md: 2,
          lg: 3
        },
        position: 'relative'
      }}>
        {!!content && <Typography variant="body1" html fuck_p_tags>{content}</Typography>}
        {!!children && children}
        {!!copyable && <IconButton
          color="primary"
          sx={{
            position: 'absolute',
            top: {
              xs: !!lessPadding ? -8 : -4,
              md: !!lessPadding ? -8 : 12
            },
            right: 8
          }}
          title={he.decode(t("nw.emission.steps.stock.order_detail.cta_hint.copy").replace(/<[^>]*>?/gm, ''))}
          onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(he.decode((content || '').replace(/<[^>]*>?/gm, '')));
          }}
        >
          <ContentCopyIcon />
        </IconButton>}
      </Grid>

      {!!divider && <Grid item xs={12}>
        <Divider />
      </Grid>}
    </>;
  }
  
  return <>
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 20,
        height:'auto'
      }
    }}>
      <Grid container spacing={0} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 4
      }}>
        {subStep < 4 && <Grid item xs={12} sx={{textAlign: 'center', marginBottom: 8}}>
          <Stepper activeStep={subStep + 1} steps={5} />
        </Grid>}
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Typography variant="h1" sx={{
            display: 'inline-block',
          }}>{t("nw.emission.buy_gift.title")}</Typography>
        </Grid>
        {!user?.id && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
          <Typography variant="subtitle1" html fuck_p_tags sx={{
            display: 'inline-block',
          }}>{t("nw.emission.buy_gift.subsection")}</Typography>
        </Grid>}
        {!!validateError && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
          <Typography variant="subtitle1" html fuck_p_tags sx={{
            display: 'inline-block',
            color: theme.palette.warning.main,
          }}>{t("nw.emission.buy_gift.subsection_validate_error")}</Typography>
        </Grid>}
        {/* {!!user?.id && (user?.vennoot_number || '')[0] === "A" && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
          <Typography variant="subtitle1" html fuck_p_tags sx={{
            display: 'inline-block',
          }}>{t("nw.emission.buy_gift.subsection_logged_in_as_a")}</Typography>
        </Grid>} */}
        {!!user?.id && user?.guardian && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
          <Typography variant="subtitle1" html fuck_p_tags sx={{
            display: 'inline-block',
          }}>{t("nw.emission.buy_gift.subsection_logged_in_as_guardian")}</Typography>
        </Grid>}
        {!!user?.id && !user?.guardian && <>
          {!!user?.id && subStep === 0 && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
            }}>{t("nw.emission.buy_gift.subsection_logged_in_step_amount")}</Typography>
          </Grid>}
          {!!user?.id && subStep === 1 && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
            }}>{t("nw.emission.buy_gift.subsection_logged_in_step_name")}</Typography>
          </Grid>}
          {!!user?.id && subStep === 2 && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
            }}>{t("nw.emission.buy_gift.subsection_logged_in_step_email")}</Typography>
          </Grid>}
          {!!user?.id && subStep === 3 && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
            }}>{t("nw.emission.buy_gift.subsection_logged_in_step_overview")}</Typography>
          </Grid>}
          {!!user?.id && subStep === 4 && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
            }}>{t("nw.emission.buy_gift.subsection_logged_in_step_success", {email: email})}</Typography>
          </Grid>}
        </>}

        {!!user?.id && !user?.guardian && <>
          {!!user?.id && subStep === 0 && <>
            <Grid item xs={12} sx={{marginBottom: 2.5}}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 4,
                marginRight: 'auto',
                marginLeft: 'auto'
              }}>
                <Typography variant="caption">{t(`nw.emission.steps.gift.field.amount`)}</Typography>
                <TextInput
                  value={amount?.toString() || ''}
                  id='amount'
                  onChange={(v) => {
                    let a = parseInt(v, 10);
                    if (!a || a < 1 || a > 200) a = 0;
                    setAmount(a);
                  }}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                    marginTop: 0
                  }}
                />
                <Typography variant="body1">{t("nw.emission.steps.stock.field.amount_calculated", {
                  amount: (amount * 50).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                })}</Typography>
              </Box>
            </Grid>

            {subBtns(-1, 1, (!amount || amount < 1 || amount > 200))}
          </>}

          {!!user?.id && subStep === 1 && <>
            <Grid item xs={12}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 4,
                marginRight: 'auto',
                marginLeft: 'auto'
              }}>
                <TextInput
                  value={firstName || ''}
                  onChange={(v) => {
                    setFirstName(v.toString());
                  }}
                  starred
                  caption={t("nw.emission.steps.gift.field.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Box>
            </Grid>
            {subBtns(0, 2, (!firstName))}
          </>}

          {!!user?.id && subStep === 2 && <>
            <Grid item xs={12}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 4,
                marginRight: 'auto',
                marginLeft: 'auto'
              }}>
                <TextInput
                  value={email || ''}
                  onChange={(v) => {
                    setEmail(v.toString());
                  }}
                  starred
                  caption={t("nw.emission.steps.gift.field.email")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Box>
            </Grid>
            {subBtns(1, 3, (!email || !emailCheck(email || '')))}
          </>}

          {!!user?.id && subStep === 3 && <>
            <Grid item xs={12}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 4,
                marginRight: 'auto',
                marginLeft: 'auto'
              }}>
                <Typography variant="caption">{t("nw.emission.steps.gift.overview.amount")}</Typography>
                <Typography variant="body1" sx={{paddingLeft: 2}}><ShareShower share="B" amount={amount} asString /></Typography>
                <Divider sx={{marginTop: 1, marginBottom: 1}} />
                <Typography variant="caption">{t("nw.emission.steps.gift.overview.first_name")}</Typography>
                <Typography variant="body1" sx={{paddingLeft: 2}}>{firstName}</Typography>
                <Divider sx={{marginTop: 1, marginBottom: 1}} />
                <Typography variant="caption">{t("nw.emission.steps.gift.overview.email")}</Typography>
                <Typography variant="body1" sx={{paddingLeft: 2}}>{email}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 2,
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'right'
              }}>
                <Box sx={{
                  display: 'inline-block',
                  width: {
                    xs: '100%',
                    lg: '49%'
                  },
                  textAlign: 'left',
                  float: 'left'
                }}>
                  <TextButton
                    label={t("nw.emission.forgot.cta_back")}
                    id="sub_btn"
                    onClick={() => {
                      setSubStep(2);
                      setTimeout(() => {lenis.scrollTo(0);}, 200);
                    }}
                    sx={{
                      marginBottom: 1,
                      color: theme.palette.primary.dark,
                      textDecoration: 'underline',
                      "&:hover": {
                        color: theme.palette.primary.light,
                        backgroundColor: 'transparent'
                      },
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  />
                </Box>
                <Box sx={{
                  display: 'inline-block',
                  width: {
                    xs: '100%',
                    lg: '49%'
                  },
                  marginLeft: 'auto',
                  textAlign: 'right'
                }}>
                  <DarkGreenButton
                    label={t("nw.emission.steps.gift.cta_finish")}
                    id="sub_btn"
                    loading={mutationCustomAction.isPending}
                    sx={{
                      marginBottom: 1,
                      borderColor: theme.palette.primary.dark,
                      "&:hover": {
                        borderColor: theme.palette.primary.dark,
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.primary.dark,
                      },
                      "&.Mui-disabled": {
                        color: 'grey',
                      },
                    }}
                    onClick={() => {
                      mutationCustomAction.mutate({
                        formData: {
                          object: 'emission_key',
                          class_action: 'custom_api_buy_gift',
                          user_id: user?.id,
                          amount: amount,
                          first_name: firstName,
                          email: email
                        },
                        step: 1
                      });
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </>}

          {!!user?.id && subStep === 4 && <>
            {theKey?.asn_key && <>
              <Grid item xs={12} sx={{
                marginBottom: 2.5,
                marginTop: 4
              }}>
                <Box
                  sx={{
                    width: {
                      xs: '100%',
                      md: '100%',
                      lg: '670px'
                    },
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    backgroundColor: 'white'
                  }}
                >
                  <Grid container spacing={0}>
                    {tableRow(
                      t("nw.emission.steps.stock.order_detail.time_requested"), 
                      theKey.time_requested, 
                      undefined, 
                      true
                    )}

                    {tableRow(
                      t("nw.emission.steps.stock.order_detail.amount"), 
                      undefined, 
                      <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={theKey.proposed_amount} share="B" />, 
                      true
                    )}

                    {tableRow(
                      t("nw.emission.steps.stock.order_detail.payment"), 
                      t("nw.emission.steps.stock.order_detail.payment_not_received"), 
                      undefined, 
                      true
                    )}

                    {tableRow(
                      t("nw.emission.steps.stock.order_detail.payment_title.amount"), 
                      `${parseInt(theKey.proposed_value?.toString() || '-1', 10)} EUR`, 
                      <IconButton color="primary" sx={{position: 'absolute', top: 8, right: 8}} title={he.decode(t("nw.emission.steps.stock.order_detail.cta_hint.qr_code").replace(/<[^>]*>?/gm, ''))} onClick={(e) => {
                        setShowQr(true);
                      }}>
                        <QrCodeIcon />
                      </IconButton>, 
                      false,
                      false
                    )}

                    {tableRow(
                      t("nw.emission.steps.stock.order_detail.payment_title.account"), 
                      t("nw.emission.steps.stock.order_detail.payment_title.account_value"), 
                      undefined, 
                      false,
                      true,
                      true
                    )}

                    {tableRow(
                      t("nw.emission.steps.stock.order_detail.payment_title.strucmed"), 
                      theKey.asn_key, 
                      undefined, 
                      true,
                      true
                    )}
                  </Grid>
                </Box>
              </Grid>
            </>}
          </>}
        </>}








        {!user?.id && <>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Box sx={{
              display: 'inline-block',
              width: {
                xs: '100%',
                lg: '440px'
              },
              textAlign: 'left'
            }}>
              <Vennr
                value={vennr || ''}
                onChange={(v) => {
                  setVennr(v.target.value);
                }}
                starred
                caption={t("nw.register.form.lidnummer")}
                // placeholder={t("nw.contact.form.placeholder.first_name")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />
              <Birthdate
                value={birthdate || ''}
                hideError={(birthdate || "_").indexOf("_") > -1}
                onChange={(v) => {
                  setBirthdate(v.target.value);
                }}
                starred
                caption={t("nw.user_info.birth_date")}
                // placeholder={t("nw.contact.form.placeholder.first_name")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />
              {!!showOtp && <OtpCode
                value={otp || ''}
                onChange={(v) => {
                  setOtp(v.target.value);
                }}
                starred
                caption={t("nw.public.otp_code")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />}
            </Box>
          </Grid>

          <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
            <Box sx={{
              display: 'block',
              width: '100%',
              maxWidth: {
                xs: '100%',
                lg: '440px'
              },
              marginTop: 2,
              marginRight: 'auto',
              marginLeft: 'auto',
              textAlign: 'right'
            }}>
              <Box sx={{
                display: 'inline-block',
                width: {
                  xs: '100%',
                  lg: '49%'
                },
                textAlign: 'left',
                float: 'left'
              }}>
                <TextButton
                  label={t("nw.emission.forgot.cta_back")}
                  id="sub_btn"
                  onClick={() => {
                    setStep(-1);
                    setOtp('');
                    setTimeout(() => {lenis.scrollTo(0);}, 200);
                  }}
                  sx={{
                    marginBottom: 1,
                    color: theme.palette.primary.dark,
                    textDecoration: 'underline',
                    "&:hover": {
                      color: theme.palette.primary.light,
                      backgroundColor: 'transparent'
                    },
                    paddingLeft: 0,
                    paddingRight: 0
                  }}
                />
              </Box>
              <Box sx={{
                display: 'inline-block',
                width: {
                  xs: '100%',
                  lg: '49%'
                },
                marginLeft: 'auto',
                textAlign: 'right'
              }}>
                <DarkGreenButton
                  label={t("nw.register.hero.cta")}
                  id="sub_btn"
                  sx={{
                    marginBottom: 1,
                    borderColor: theme.palette.primary.dark,
                    "&:hover": {
                      borderColor: theme.palette.primary.dark,
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.dark,
                    },
                    "&.Mui-disabled": {
                      color: 'grey',
                    },
                  }}
                  disabled={!vennr || !birthdate || (!!showOtp && !otp)}
                  onClick={() => {
                    mutationCustomAction.mutate({
                      formData: {
                        object: 'user',
                        class_action: 'custom_api_validate',
                        birthdate: birthdate,
                        vennr: vennr,
                        otp: otp.replace(" ", "").replace("_", ""),
                        basic_info: 1
                      },
                      step: 0
                    });
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </>}

        {!!user?.id && (!!user?.id && user?.guardian) && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
          <TextButton
            id="back_btn"
            label={t("nw.emission.forgot.cta_back")}
            onClick={() => {
              setStep(0);
              setTimeout(() => {lenis.scrollTo(0);}, 200);
            }}
            sx={{
              marginLeft: 1,
              marginRight: 1,
              marginTop: 1
            }}
          />
        </Grid>}
      </Grid>
    </WhiteSection>

    <Dialog
      open={showQr}
      disableScrollLock
      onClose={() => {
        setShowQr(false);
      }}
    >
      <DialogTitle><Typography>{t("nw.emission.steps.stock.qr_confirm.title")}</Typography></DialogTitle>
      <DialogContent>
        <DialogContentText sx={{textAlign: 'center'}}>
          <Typography sx={{textAlign: 'left'}} html>{t("nw.emission.steps.stock.qr_confirm.body")}</Typography>
          {!!theKey && <QRCode value={`BCD\n001\n1\nSCT\nARSPBE22\nArgen-Co CV\nBE84973171450059\nEUR${theKey.proposed_value}\n\n${theKey?.asn_key}\n\n`} />}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          setShowQr(false);
        }}>{he.decode(t("nw.emission.steps.stock.qr_confirm.cta_ok").replace(/<[^>]*>?/gm, ''))}</Button>
      </DialogActions>
    </Dialog>
  </>;
}

